import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules'

window.addEventListener('load', function () {
  const main = document.querySelector('main')
  if (!main || !main.classList.contains('top')) return

  const kvSwiper = new Swiper('.kv-swiper', {
    modules: [Pagination, Navigation, Autoplay, EffectFade],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 1000,
    watchOverflow: true,
    effect: 'fade',
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.kv-pagination',
      clickable: true,
    },
  })

  /**
   * SP時のみ：
   * .sec01 .content が画面中央を通過したら .is-current を付与
   * 中央から外れたら削除
   */
  const mediaQuery = window.matchMedia('(max-width: 768px)')
  const contents = document.querySelectorAll('.sec01 .content')

  if (!contents.length) return

  function updateCurrentContent() {
    if (!mediaQuery.matches) {
      contents.forEach(function (content) {
        content.classList.remove('is-current')
      })
      return
    }

    const viewportCenter = window.innerHeight / 2

    contents.forEach(function (content) {
      const rect = content.getBoundingClientRect()

      if (rect.top <= viewportCenter && rect.bottom >= viewportCenter) {
        content.classList.add('is-current')
      } else {
        content.classList.remove('is-current')
      }
    })
  }

  updateCurrentContent()

  window.addEventListener('scroll', updateCurrentContent, { passive: true })
  window.addEventListener('resize', updateCurrentContent)
})
